module.exports = __webpack_public_path__ + "static/media/DSC00475.bbefefc9.jpg";